module.exports = require("update-notifier");


//////////////////
// WEBPACK FOOTER
// external "update-notifier"
// module id = 200
// module chunks = 0